<template>
	<UiElement
		class="text-uppercase"
		tag="button"
		:settings="settings"
		@touchstart="changeLanguage"
	>
		{{ nextLocale }}
	</UiElement>
</template>

<script setup>
	import { defineProps, computed } from 'vue';
	import UiElement from '@/components/UI/UiElement.vue';
	import { storeToRefs } from 'pinia';
	import { useKioskStore } from '@/stores/useKioskStore';

	defineProps({
		settings: {
			type: Object,
			required: true
		}
	});

	const { locale } = storeToRefs(useKioskStore());

	const currentLocale = computed(() => locale.value);
	const nextLocale = computed(() => (currentLocale.value === 'en' ? 'cs' : 'en'));

	function changeLanguage() {
		locale.value = nextLocale.value
		// router.push({
		// 	name: route.name,
		// 	params: {
		// 		...route.params,
		// 		locale: nextLocale.value
		// 	},
		// 	query: route.query,
		// });
	}
</script>
